import { render, staticRenderFns } from "./ignoreModal.vue?vue&type=template&id=963f755a"
import script from "./ignoreModal.vue?vue&type=script&lang=js"
export * from "./ignoreModal.vue?vue&type=script&lang=js"
import style0 from "./ignoreModal.vue?vue&type=style&index=0&id=963f755a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports